import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';

import QAmountField from 'components/QAmountField';

import InvestmentTransactionBaseForm from './InvestmentTransactionBaseForm';

const InvestmentTransactionBuyBondsForm = (props) => {
  const { formik } = props;

  const [pricePerUnit, setPricePerUnit] = useState();
  const [accruedInterest, setAccruedInterest] = useState();

  useEffect(() => {
    formik.registerField('amount', { validate: (value) => (value ? undefined : 'please enter valid amount') });
    formik.registerField('units', {
      validate: (value) => (typeof value === 'number' && value ? undefined : 'field is required'),
    });
    return () => {
      formik.unregisterField('amount');
      formik.unregisterField('units');
    };
  }, [formik]);

  const { setFieldValue } = formik;
  useEffect(() => {
    const commission = typeof formik.values.commission === 'number' ? formik.values.commission : 0;
    const units = typeof formik.values.units === 'number' ? Math.abs(formik.values.units) : 0;
    let costBasis = typeof formik.values.costBasis === 'number' ? formik.values.costBasis : 0;

    if (!accruedInterest && !pricePerUnit && formik.values.amount && costBasis) {
      const newAccruedInterest = formik.values.amount - costBasis;
      if (newAccruedInterest !== accruedInterest) {
        setAccruedInterest(newAccruedInterest);
      }
    }

    if (pricePerUnit) {
      costBasis = -(units * pricePerUnit - commission);
      if (formik.values.costBasis !== costBasis) {
        setFieldValue('costBasis', costBasis);
      }
    }

    if (!pricePerUnit && costBasis && units) {
      const newPricePerUnit = (Math.abs(costBasis) + commission) / units;
      if (pricePerUnit !== newPricePerUnit) {
        setPricePerUnit(newPricePerUnit);
      }
    }

    if (costBasis) {
      const amount = costBasis + (accruedInterest || 0);
      if (formik.values.amount !== amount) {
        setFieldValue('amount', amount);
      }
    }
  }, [
    setFieldValue,
    formik.values.amount,
    formik.values.units,
    pricePerUnit,
    accruedInterest,
    formik.values.commission,
    formik.values.costBasis,
  ]);

  return (
    <>
      <InvestmentTransactionBaseForm formik={formik} />

      <Box display='flex' gap={1}>
        <Box display='flex' flexDirection='column' gap={3}>
          <Box display='flex' alignItems='center' gap={1}>
            <QAmountField
              id='face-value'
              editable
              label='Face value'
              sx={{ minWidth: 110 }}
              noNegatives
              value={Math.abs(formik.values.units) * 100}
              onChange={(event) => formik.setFieldValue('units', Number(event.target.value) / 100)}
              error={Boolean(formik.submitCount > 0 && formik.errors.units)}
              helperText={(formik.submitCount > 0 && formik.errors.units) || ''}
            />
            /<nobr>100</nobr>
          </Box>
        </Box>

        <Box display='flex' flexDirection='column' gap={3}>
          <Box display='flex' gap={1} alignItems='center'>
            =
            <TextField
              id='shares'
              label='Shares'
              type='number'
              inputProps={{ min: 1 }}
              sx={{ minWidth: 110 }}
              disabled
              value={Math.abs(formik.values.units)}
            />
            *
            <QAmountField
              id='price-per-share'
              editable
              sx={{ minWidth: 110 }}
              label='Price (per $100)'
              noNegatives
              value={pricePerUnit}
              onChange={(event) => setPricePerUnit(Number(event.target.value))}
              error={Boolean(formik.submitCount > 0 && formik.errors.amount)}
              helperText={(formik.submitCount > 0 && formik.errors.amount) || ''}
            />
            +
            <QAmountField
              id='commission'
              editable
              sx={{ minWidth: 110 }}
              value={formik.values.commission}
              onChange={(event) => formik.setFieldValue('commission', Number(event.target.value))}
              label='Commission'
            />
          </Box>

          <Box display='flex' alignItems='center' gap={1}>
            =
            <QAmountField
              id='cost-basis'
              editable
              disabled
              InputProps={{
                readOnly: true,
              }}
              sx={{ minWidth: 110 }}
              label='Principal/cost basis'
              value={formik.values.costBasis}
            />
            +
            <QAmountField
              id='accrued-interest'
              editable
              sx={{ minWidth: 110 }}
              label='Accrued interest'
              value={accruedInterest}
              onChange={(event) => setAccruedInterest(Number(event.target.value))}
            />
          </Box>

          <Divider />

          <Box display='flex' gap={1}>
            =
            <QAmountField
              id='total-amount'
              editable
              disabled
              label='Total amount'
              sx={{ minWidth: 110 }}
              noNegatives
              value={Math.abs(formik.values.amount)}
              // onChange={(event) => formik.setFieldValue('amount', Number(event.target.value))}
              // error={Boolean(formik.submitCount > 0 && formik.errors.amount)}
              // helperText={(formik.submitCount > 0 && formik.errors.amount) || ''}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

InvestmentTransactionBuyBondsForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default InvestmentTransactionBuyBondsForm;
